<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Primærværdi</mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        <dt>Antal decimaler</dt>
        <dd>{{value.decimals}}</dd>
      </dl>
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" class="mb-3">
        <div fxFlex="45" fxLayout="column">
          <label id="decimals_label">Antal decimaler ({{decimals.value}})</label>
          <mat-slider min="0" max="3" step="1" discrete showTickMarks>
            <input matSliderThumb formControlName="decimals" aria-labelledby="decimals_label">
          </mat-slider>
          <mat-hint>Antal decimaler i primærværdi-søjlen..</mat-hint>
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="doCancel()">Fortryd</button>
        <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
